
import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/components/headers/form-header/form-header.vue';

import InputCCNumber from '@/components/inputs/text/cc_number.input.vue';
import InputCCType from '@/components/inputs/text/cc_type.input.vue';
import InputName from '@/components/inputs/text/name.input.vue';
import InputAge from '@/components/inputs/text/age.input.vue';
import InputEps from '@/components/inputs/text/eps.input.vue';
import InputEmail from '@/components/inputs/text/email.input.vue';
import InputPhone from '@/components/inputs/text/phone.input.vue';
import InputAddress from '@/components/inputs/text/address.input.vue';
import InputCity from '@/components/inputs/text/city.input.vue';

import InputPark from '@/components/inputs/options/park.input.vue';
import InputClientType from '@/components/inputs/options/client-type.input.vue';

import { IUser } from '@/models/IUser.model';
import SignUpHelper from '@/helpers/signup.helper';
@Component({
  components: {
    'form-header': FormHeader,
    'input-cc-number': InputCCNumber,
    'input-cc-type': InputCCType,
    'input-name': InputName,
    'input-age': InputAge,
    'input-eps': InputEps,
    'input-email': InputEmail,
    'input-phone': InputPhone,
    'input-address': InputAddress,
    'input-city': InputCity,
  },
})
export default class SignUpView extends Vue {

  private cc_number: string = '';
  private parkId: string = '';
  private clientType: string = '';

  private cc_type: string = '';
  private name: string = '';
  private phone: string = '';
  private age: string = '';
  private eps: string = '';
  private email: string = '';
  private address: string = '';
  private city: string = '';
  private parent: any = {
    cc_type: '',
    cc_number: '',
    name:  '',
    age: '',
    eps: '',
    phone: '', email: '',
    address: '',
    city: '',
  };

  private HABEAS_DATA: string = ''

  private mounted() {
    this.cc_number = this.$route.params.cc;
    this.parkId = this.$route.params.park;
    this.clientType = this.$route.params.clientType;
    this.parent = {
      cc_type: '',
      cc_number: '',
      name:  '',
      age: '',
      eps: '',
      phone: '', email: '',
      address: '',
      city: '',
    };

  }

  setCity($text) {
    this.city = $text;
  }
  setAddress($text) {
    this.address = $text;
  }
  setEmail($text) {
    this.email = $text;
  }
  setPhone($text) {
    this.phone = $text;
  }
  setEps($text) {
    this.eps = $text;
  }
  setAge($text) {
    this.age = $text;
  }
  setName($text) {
    this.name = $text;
  }
  setCCNumber($text) {
    this.cc_number = $text;
  }
  setCCType($text) {
    this.cc_type = $text
  }

  setCityParent($text) {
    this.parent.city = $text;
  }
  setAddressParent($text) {
    this.parent.address = $text;
  }
  setEmailParent($text) {
    this.parent.email = $text;
  }
  setPhoneParent($text) {
    this.parent.phone = $text;
  }
  setEpsParent($text) {
    this.parent.eps = $text;
  }
  setAgeParent($text) {
    this.parent.age = $text;
  }
  setNameParent($text) {
    this.parent.name = $text;
  }
  setCCNumberParent($text) {
    this.parent.cc_number = $text;
  }
  setCCTypeParent($text) {
    this.parent.cc_type = $text
  }

  async doSignUp() {
    if(this.HABEAS_DATA !== "yes") {
      this.$swal('Aceptar Politicas de Datos', 'Es necesario aceptar politicas de datos para continuar', 'error')
      return false;
    } else {
    if (this.checkSignUp()) {
      try {

        await SignUpHelper({
          cc_type: this.cc_type,
          cc_number: this.cc_number,
          name: this.name,
          email: this.email,
          city: this.city,
          phone: this.phone,
          address: this.address,
          age: this.age,
          eps: this.eps,
          parent: this.parent
        } as IUser);

        console.clear()
        console.warn({
          cc_type: this.cc_type,
          cc_number: this.cc_number,
          name: this.name,
          email: this.email,
          city: this.city,
          phone: this.phone,
          address: this.address,
          age: this.age,
          eps: this.eps,
        } )

        console.warn('this.cc_number')
        console.warn(this.cc_number)


        console.warn(' debuggin dispatch p1')
        await this.$store.dispatch('fetchUserByCC',this.cc_number)

        console.warn('this.store.state.user')
        console.warn(this.$store.state.user)

        this.$router.push({ name: 'BookingViewParams', params: { cc:this.cc_number, park: this.parkId, clientType: this.clientType} });
        // this.$swal('Usuario Registrado Exitosamente', '', 'success')

      } catch (error) {
        this.$swal('Error Registrando Usuario', JSON.stringify(error), 'error')
      }

    } else {
      this.$swal('Formulario Incompleto o Invalido', '', 'error')
    }
  }
  }

  checkSignUp(): boolean {



    if (
      this.cc_type &&
      this.cc_number &&
      this.name &&
      this.age &&
      this.eps &&
      this.phone &&
      this.email &&
      this.address &&
      this.city
    ) return true;
    console.error({
      cc_type: this.cc_type,
      cc_number: this.cc_number,
      name: this.name,
      age: this.age,
      eps: this.eps,
      phone: this.phone,
      email: this.email,
      address: this.address,
      city: this.city
    }
    )
    return false;
  }


}